export const UPDATE_ACTIONS = {
  add: 'add',
  remove: 'remove',
};
